module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_lachen-eb22aabbfa7198b5e083b1a996906b22.png";